export default {
  path: '/home',
  component: () => import('@/components/home.vue'),
  children: [
    {
      path: 'wm',
      name: 'wm',
      component: () => import('@/pages/home/wm.vue'),
      meta: {
        keepAlive: true,
        title: '', // 物贸(首页)
      },
    },
    {
      path: 'ck',
      name: 'ck',
      component: () => import('@/pages/home/ck.vue'),
      meta: {
        keepAlive: true,
        title: '', // 城矿(首页)
      },
    },
    {
      path: 'dsly',
      name: 'dsly',
      component: () => import('@/pages/home/dsly.vue'),
      meta: {
        keepAlive: true,
        title: '', // 多式联运(首页)
      },
    },
    {
      path: 'wy',
      name: 'wy',
      component: () => import('@/pages/home/wy.vue'),
      meta: {
        keepAlive: true,
        title: '', // 物业(首页)
      },
    },
    {
      path: 'cc',
      name: 'cc',
      component: () => import('@/pages/home/cc.vue'),
      meta: {
        keepAlive: true,
        title: '', // 仓储(首页)
      },
    },
    {
      path: 'cd',
      name: 'cd',
      component: () => import('@/pages/home/cd.vue'),
      meta: {
        keepAlive: true,
        title: '', // 仓单(首页)
      },
    },
  ],
};
